import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue';

const VIEWPORT_BOTTOM_BUFFER = 16;

/**
 * Caps a dropdown panel to the viewport space left below its top edge, so a
 * panel opened low on the screen scrolls internally instead of overflowing it.
 * Bind `panelRef` to the element and `maxHeight` (in px) to its max-height.
 */
export function useViewportMaxHeight({ min = 200, max = 500 } = {}) {
  const panelRef = ref(null);
  const maxHeight = ref(max);

  const update = () => {
    if (!panelRef.value) return;
    const { top } = panelRef.value.getBoundingClientRect();
    const available = window.innerHeight - top - VIEWPORT_BOTTOM_BUFFER;
    maxHeight.value = Math.max(min, Math.min(max, available));
  };

  onMounted(async () => {
    await nextTick();
    update();
    window.addEventListener('resize', update);
    window.addEventListener('scroll', update, true);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', update);
    window.removeEventListener('scroll', update, true);
  });

  return { panelRef, maxHeight };
}
